<template>
    <div class="details">
        <div class="progress">
            <div style="margin-left: 47px;margin-top: 30px;width: 16%;display: flex;">
                <h1 style="font-size: 18px;font-family: PingFang SC, PingFang SC;font-weight: bold;color: #333333;">订单进度
                </h1>
                <el-button style="margin-left: 15px;margin-top: 10px;">返回</el-button>
            </div>
            <div style="width: 100%;padding-top: 22px;">
                <el-steps :active="orderStatus" align-center>
                    <el-step title="待接单" />
                    <el-step title="待生产" />
                    <el-step title="待收货" />
                    <el-step title="待评价" />
                    <el-step title="已完成" />
                </el-steps>
            </div>
        </div>
        <div class="orderdetails">
            <h1 class="title">订单详情</h1>
            <hr style="margin-left: 43px;margin-right: 43px;margin-top: 12px;">
            <div class="orderStatus">
                <ul style="display: flex;justify-content: space-around;">
                    <li>
                        <div>
                            <p class="orderTitle">订单开始时间</p>
                            <p class="orderMain">{{msgList.createTime}}</p>
                        </div>
                    </li>
                    <li>
                        <div>
                            <p class="orderTitle">订单交付时间</p>
                            <p class="orderMain">{{ msgList.deliveryTime }}</p>
                        </div>
                    </li>
                    <li>
                        <div>
                            <p class="orderTitle">订单状态</p>
                            <p class="orderMain" style="color: #14C1AD;">{{ msgList.orderState }}</p>
                        </div>
                    </li>
                    <li>
                        <div>
                            <p class="orderTitle">全厂摄像头</p>
                            <p class="orderMain" style="color: #002FA7;">查看</p>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="introduction">
                <div class="imgBox">
                    <img src="../../../assets/img/introdute.png" alt="" width="100%" height="100%">
                </div>
                <div style="margin-top: 20px;margin-left: 31px;">
                    <p
                        style="text-align: left; font-size: 18px;font-family: PingFang SC, PingFang SC;font-weight: bold;color: #333333;">
                        威海市汇泉工业有限公司</p>
                    <p class="main">山东汇泉工业有限公司创建于1966年，下设五个服装子厂、一家进出口公司及一家面料染织公司。</p>
                    <p class="main">在美国、香港、北京、上海、山东等地设立了分公司和办事机构。</p>
                </div>
            </div>
        </div>
        <div class="productdetails">
            <div>
                <div style="display: flex;justify-content: space-between;"> 
                    <h1 class="title">商品详情</h1>
                    <div style="font-size: 16px;font-family: PingFang SC, PingFang SC;font-weight: bold;color: #002FA7;margin-right: 52px;margin-top: 20px;">总数：{{ calculateTotalQuantity() }}</div>
                </div>
            <hr style="margin-left: 31px;margin-right: 24px;">
            <div style="margin-left: 31px;display: flex;flex-direction: column;text-align: left;" v-for="(item,index) in tableList" :key="index" >
                <p style="font-size: 16px;font-family: PingFang SC, PingFang SC;font-weight: bold;color: #333333;">商品{{ index+1 }}</p>
                <div style="display: flex;gap: 54px;">
                    <p style="font-size: 14px;font-family: PingFang SC, PingFang SC;font-weight: 500;color: #333333;">商品名称：{{ item.productName }}</p>
                    <p style="font-size: 14px;font-family: PingFang SC, PingFang SC;font-weight: 500;color: #333333;">商品类型：{{ item.productType }}</p>
                </div>
                <tr class="tr">
                  <td class="td"></td>
                  <td class="td" style="font-weight: 700;" v-for="(i, ci) in item.productDatailVos[0].colorList[0].skulists">
                    {{ i.skuSize }}
                  </td>
                  <td class="td" style="font-weight: 700;">总数</td>
                </tr>
                <tr class="tr2" v-for="(s, dex) in item.productDatailVos[0].colorList" :key="dex">
                  <td class="td">{{ s.color }}</td>
                  <td class="td" v-for="(e, ind) in s.skulists" :key="ind">
                    {{ e.number }}
                  </td>
                  <td class="td">
                    {{ calculateSum(s.skulists) }}
                  </td>
                </tr>
            </div>
            </div>
        </div>
        <div class="orderBottom">
            <el-button class="cancel" @click="goback">返回</el-button>
            <el-button class="shouhuoBtn" @click="clintBtn" v-if="orderStatus == 3">确认收货</el-button>
            <el-button class="shouhuoBtn"  @click="evaluteBtn" v-if="orderStatus == 4">去评价</el-button>
            <el-button class="shouhuoBtn" style="background-color: #777777;" disabled  v-if="orderStatus == 5">已完成</el-button>
        </div>  
        <el-dialog v-model="dialogVisible" title="评价" width="30%" :before-close="handleClose" style="text-align: left;">
            <div>
                <span class="demonstration"
                    style="font-size: 16px;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #333333;">请您对本次订单进行评价</span>
                <el-rate v-model="remark" style="vertical-align: sub;margin-left: 37px;" />
            </div>
            <div style="display: flex;margin-top: 30px;">
                <span class="demonstration"
                    style="font-size: 16px;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #333333;width: 10%;">备注</span>
                <el-input v-model="Evaluate"  type="textarea" />
            </div>
            <template #footer>
                <span class="dialog-footer">
                    <el-button style="width: 93px;height: 38px;" @click="dialogVisible = false">取消</el-button>
                    <el-button style="width: 93px;height: 38px;" type="primary" @click="evaluteQR()">
                        确认
                    </el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>

import { onMounted, ref } from 'vue';
import { useRouter,useRoute} from 'vue-router';
import { clientProductExhibition,getDicts,clintHarvest,orderEvaluation } from "@/api/order.js"
import { ElMessage, ElMessageBox } from 'element-plus'
import { computed } from 'vue';
const route = useRoute()
const router = useRouter()
const orderId = ref("")
const tableList = ref([])
const msgList = ref({})
const remark = ref("")
const Evaluate = ref("")
const dialogVisible = ref(false)

// Compute the order status description based on msgList
const orderStatus = computed(() => {
  // Assuming msgList contains the order status
  const statusValue = msgList.value.orderState; // Get the status value from msgList
  if(statusValue == "待接单") {
    return "1"
  } else if(statusValue == "待生产") {
    return "2"
  } else if(statusValue == "待收货") {
    return "3"
  } else if(statusValue == "待评价") {
    return "4"
  } else if(statusValue == "已完成") {
    return "5"
  }
});
onMounted(()=> {
    orderId.value = route.query.orderId
    getDetailsList()
})

const getDetailsList = () => {
    clientProductExhibition(orderId.value).then(res => {
        msgList.value = res.data.data
        getDicts('order_state').then(res => {
        res.data.data.map((item,index) => {
            if(item.dictValue == msgList.value.orderState) {
                msgList.value.orderState = item.dictLabel
            }
        })
    })
        tableList.value = res.data.data.commodityManages
    })
}
// 在 setup 中创建计算总和的函数
const calculateSum = (skulists) => {
  // 遍历 skulists 中的每个元素的 number 属性并将其相加
  let sum = 0;
  skulists.forEach((e) => {
    sum += parseFloat(e.number); // 转换为数字并相加
  });   
  return sum; // 返回总和
};
// 计算商品总数的函数
const calculateTotalQuantity = () => {
  let totalQuantity = 0;
  tableList.value.forEach((item) => {
    item.productDatailVos.forEach((detail) => {
      detail.colorList.forEach((color) => {
        color.skulists.forEach((sku) => {
          totalQuantity += parseFloat(sku.number) || 0; // 将每个商品数量相加
        });
      });
    });
  });
  return totalQuantity;
};
//确认收货
const clintBtn = () => {
    ElMessageBox.confirm(
        '是否确认已经收到货物？',
        '提示',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }
    ).then(() => {
        clintHarvest(orderId.value).then(res => {
            if (res.data.code == 200) {
                ElMessage.success("收货成功")
                getDetailsList()
            }
        })
    })
}

const goback = () => {
    router.go(-1)
}
//评价
const evaluteBtn = () => {
    dialogVisible.value = true
}
const evaluteQR = () => {
    let obj = {
        orderId: orderId.value,
        remark:Evaluate.value,
        orderEvaluate:remark.value
    }
    orderEvaluation(obj).then(res => {
        if(res.data.code == 200) {
            ElMessage.success("评价成功")
            remark.value = ""
            Evaluate.value = ""
            dialogVisible.value = false
            getDetailsList()
        }
    })
}
</script>

<style scoped>
.details {
    /* height: 1607px; */
    background: #F8F8F8;
    border-radius: 0px 0px 0px 0px;
    overflow: hidden;
}

.progress {
    margin: 34px 360px;
    /* height: 110px; */
    background: #FFFFFF;
    border-radius: 10px 10px 10px 10px;
    opacity: 1;
    display: flex;
    padding-bottom: 21px;
    margin-bottom: 0
}

::v-deep .el-step__icon {
    width: 39px;
    height: 39px;
    background: #002FA7;
    opacity: 1;
    border: 1px solid #DDDDDD;
    color: #fff;
}

.orderdetails {
    /* height: 441px; */
    background: #FFFFFF;
    border-radius: 10px 10px 10px 10px;
    opacity: 1;
    margin: 20px 360px;
    overflow: hidden;
    padding-bottom: 39px;
}

.title {
    font-size: 20px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    color: #333333;
    text-align: left;
    margin-left: 42px;
    margin-top: 19px;
}

.orderStatus {
    height: 124px;
    background: #FFFFFF;
    border-radius: 10px 10px 10px 10px;
    opacity: 1;
    border: 1px solid #DDDDDD;
    margin: 18px 43px 10px 42px;
}

.orderTitle {
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    color: #777777;
}

.orderMain {
    font-size: 18px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    color: #333333;
}

.introduction {
    height: 195px;
    background: #FFFFFF;
    border-radius: 10px 10px 10px 10px;
    opacity: 1;
    border: 1px solid #DDDDDD;
    margin: 18px 43px 0px 42px;
    display: flex;
}

.imgBox {
    width: 216px;
    height: 140px;
    margin-left: 26px;
    margin-top: 27px;
}

.main {
    font-size: 18px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    color: #777777;
    text-align: left;
}

.productdetails {
    /* height: 773px; */
    background: #FFFFFF;
    border-radius: 10px 10px 10px 10px;
    opacity: 1;
    margin: 16px 360px;
    overflow: hidden;
    padding-bottom: 43px;
    margin-bottom: 0;
}
.title {
    font-size: 20px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    color: #333333;
    text-align: left;
    margin-left: 31px;
    margin-top: 19px;
}
.orderBottom {
    /* height: 83px; */
    padding-bottom: 22px;
    margin-top: 35px;
    background: #FFFFFF;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    text-align: right;
    padding-right: 390px;
    padding-top: 23px;
}
.shouhuoBtn {
    width: 93px;
    height: 38px;
    background: #467DEF;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid #DDDDDD;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
}
.cancel {
    width: 93px;
    height: 38px;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid #DDDDDD;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    color: #777777;
}
.tr {
    width: auto;
    height: 50px;
    background: #F7F9FD;
  }
  .tr2 {
    width: auto;
    height: 50px;
    border-bottom: 1px solid #DDDDDD;
  }
  .td {
    width: 200px;
    height: 50px;
    text-align: center;
    vertical-align: middle;
    /* border: solid 1px #f0f2f5; */
  }
  .tr3 {
    /* // width: 500px; */
    height: 50px;
  }
  .td3 {
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: 50px;
  }
  ::v-deep .el-textarea__inner {
    width: 437px;
    height: 154px!important;
}
</style>
